import React from "react";
import SectionHeading from "@/components/SectionHeading";
import useReveal from "@/hooks/useReveal";
import { MapPin } from "lucide-react";

export default function About() {
  const r = useReveal();
  return (
    <section
      id="about"
      className="section section-tone section-tone-partnerships"
      data-testid="about-section"
    >
      <div className="container-x">
        <SectionHeading
          eyebrow="About SoKno Productions"
          title="Stories with purpose."
          accent="Productions with impact."
          testId="about-heading"
        >
          A Dallas-based independent film company developing original projects with a
          focus on bold storytelling, cinematic craft, and meaningful collaboration.
        </SectionHeading>

        <div
          ref={r.ref}
          className={`panel mt-12 ${r.className}`}
          data-testid="about-card"
        >
          <div className="card-meta">The Studio</div>
          <h3
            className="font-display mt-3"
            style={{
              color: "var(--sokno-cream)",
              fontSize: "clamp(1.6rem, 2.8vw, 2rem)",
              fontWeight: 500,
              lineHeight: 1.25,
              letterSpacing: "-0.005em",
            }}
          >
            Built for independent film.
          </h3>

          <div
            className="mt-5 flex flex-col gap-5"
            style={{ color: "var(--sokno-cream-dim)", fontSize: 15.5, lineHeight: 1.75 }}
          >
            <p>
              SoKno creates space for stories, talent, producers, and creative partners
              to move strong ideas from vision to screen — original film development,
              independent production, and serious collaboration built on craft.
            </p>
            <p>
              The name{" "}
              <span style={{ color: "var(--sokno-gold-warm)" }}>“SoKno”</span> is
              derived from founder{" "}
              <span style={{ color: "var(--sokno-cream)" }}>Sophia Knolton</span>, but
              the brand represents more than a name — it represents a standard. The gold
              curtains in the SoKno logo symbolize doors opening: to stories that matter,
              to creative opportunity, and to independent film done right.
            </p>
          </div>

          <div className="hr-gold mt-8" />

          <div
            className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
            data-testid="about-positioning"
          >
            <div className="flex items-center gap-3">
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  border: "1px solid var(--sokno-line-strong)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--sokno-gold)",
                  background: "rgba(214,175,99,0.05)",
                  flexShrink: 0,
                }}
              >
                <MapPin size={16} strokeWidth={1.5} />
              </div>
              <div>
                <div className="card-meta">Based In</div>
                <div style={{ color: "var(--sokno-cream)", fontSize: 14.5 }}>
                  Dallas, Texas
                </div>
              </div>
            </div>
            <div
              className="font-script"
              style={{
                color: "var(--sokno-gold)",
                fontSize: 11,
                letterSpacing: "0.28em",
                textTransform: "uppercase",
              }}
            >
              Dallas-based · Story-driven · Built for independent film
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
